import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MessagesModule }                from '../../app-lite/messages/messages.module';
import { QuickbooksConnectionComponent } from './quickbooks.connection.component';
import { QuickbooksCountryComponent }    from './quickbooks.country.component';
import { QuickbooksSignupComponent }     from './quickbooks.signup.component';
import { QuickbooksStates }              from './quickbooks.states';
import { SharedModule }                  from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    QuickbooksConnectionComponent,
    QuickbooksCountryComponent,
    QuickbooksSignupComponent
  ],
  imports: [
    UIRouterUpgradeModule.forChild({ states: QuickbooksStates }),

    MessagesModule,
    SharedModule
  ]
})
export class QuickbooksModule {}
